/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, {
  useEffect,
  useState,
  useContext,
  useLayoutEffect,
  useCallback,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Tabs, Tab } from 'react-bootstrap'
import './crearCliente.css'
import { VAContext } from '../../../Context/VAContext'

import MiniLoading from '../../../Components/MiniLoading'

import moment from 'moment'
import { t } from 'i18next'
import {
  fetchDeleteListPrices,
  fetchCustomerById,
  fetchListPricesByCustomer,
  fetchRegisterCustomer,
  fetchSaveListPrices,
  fetchUpdateCustomer,
  fetchListCountries,
  fetchListTelephoneTypes,
  fetchListDocumentTypes,
} from 'redux/actions/clientsActions'
import {
  customerTypeId,
  documentTypeIds,
  VAPermissions,
  telephoneTypeIds,
} from 'Utils/constants'
import { TabNatural } from './components/TabNatural'
import { TabLegal } from './components/TabLegal/TabLegal'
import { AlertModal } from './components/AlertModal/AlertModal'
import { EmailModal } from './components/EmailModal/EmailModal'
import RegisteredClientModal from './components/RegisteredClientModal'
import { useFormLogic } from './hooks/useFormLogic'
import { getPriceListPayload } from './utils/getPriceListPayload'
import useValidatePermission from 'Hooks/useValidatePermission'
const initialAddressState = {
  country: false,
  province: false,
  district: false,
  township: false,
  street: false,
  detail: false,
}

const CrearCliente = ({ handleClose, needAutoclose, onSuccessUpdate }) => {
  const dispatch = useDispatch()
  const loginInfo = useSelector(state => state.login?.user?.AuthenticationInfo)
  const canUserAssignPriceLists = useValidatePermission(
    VAPermissions.canAssignPriceLists
  )

  const createComercialClient = useValidatePermission(
    VAPermissions.createComercialClient
  )

  const customerNaturalId = customerTypeId.natural
  const customerLegalId = customerTypeId.legal

  const [tipoTelefono, setTipoTelefono] = useState([])

  const [documentType, setDocumentType] = useState([])
  const [valueState, setValueState] = useState([])
  const [valueEditState, setValueEditState] = useState([])

  const [mapKey, setMapKey] = useState(null)

  const [typeClient, setTypeClient] = useState(customerNaturalId)
  const [successModal, setSuccessModal] = useState(false)
  const [successModalUpdate, setSuccessModalUpdate] = useState(false)
  const [tabNatural, setTabNatural] = useState(true)
  const [tabJuridica, setTabJuridica] = useState(true)
  const [hasErrorOnUpdate, setHasErrorOnUpdate] = useState(false)

  const { clientSelected } = useContext(VAContext)

  const [loader, setLoader] = useState(true)
  const [loadingSave, setLoadingSave] = useState(false)
  const [saveResultMessage, setSaveResultMessage] = useState('')

  const [hasAddress, setHasAddress] = useState(initialAddressState)
  const [countryCode, setCountryCode] = useState('')
  const [provinceCode, setProvinceCode] = useState('')
  const [districtCode, setDistrictCode] = useState('')
  const [townshipCode, setTownshipCode] = useState('')

  const [street, setStreet] = useState('')
  const [name, setName] = useState('')

  const [valueStateSelect, setValueStateSelect] = useState({
    Description: '',
    genderId: '',
  })

  // Estados para el modal de cliente registrado (duplicado exacto)
  const [isRegisteredClientModalOpen, setIsRegisteredClientModalOpen] =
    useState(false)
  const [registeredClient, setRegisteredClient] = useState(null)

  // Handlers para el modal de cliente registrado
  const handleOpenRegisteredClientModal = useCallback(client => {
    setRegisteredClient(client)
    setIsRegisteredClientModalOpen(true)
  }, [])

  const handleCloseRegisteredClientModal = useCallback(() => {
    setIsRegisteredClientModalOpen(false)
    setRegisteredClient(null)
  }, [])

  const clearAddress = () => {
    const clearState = {
      country: false,
      province: false,
      district: false,
      township: false,
      street: false,
      detail: false,
    }
    setHasAddress(clearState)
    setStreet('')
    setName('')
    setCountryCode('')
    setProvinceCode('')
    setDistrictCode('')
    setTownshipCode('')
  }

  const validateAndSetAddress = (formValues = {}) => {
    if (
      (hasAddress.country &&
        hasAddress.province &&
        hasAddress.district &&
        hasAddress.township &&
        hasAddress.street &&
        hasAddress.detail) ||
      clientSelected.edit
    ) {
      const finalAddress = [
        formValues?.buildingTypeId ? undefined : 'Casa', // label resolved in NewCustomerMap
        formValues?.apartmentOrStoreNumber,
        street?.trim(),
        townshipCode ? undefined : undefined, // township name not available here
      ]
        .filter(Boolean)
        .join(', ')
        .substring(0, 99)

      const homeOrFloorNumber = formValues?.homeOrFloorNumber || null

      return {
        AddressId: null,
        Name: name?.trim(),
        AddressTypeId: '90ACBCF4-BE83-4F03-8B5E-5760FC92B59B',
        CountryId: countryCode,
        ProvinceId: provinceCode,
        DistrictId: districtCode,
        TownshipId: townshipCode,
        NeighborhoodId: null,
        Street:
          formValues?.neighborhoodName ||
          formValues?.addressStreet ||
          street?.trim(),
        BuildingTypeId:
          formValues?.buildingTypeId || '18272DEA-60DB-4F71-B292-1FD44E3A2B30',
        BuildingId: null,
        ApartmentOrStoreNumber: formValues?.apartmentOrStoreNumber || null,
        HomeOrFloorNumber: homeOrFloorNumber,
        HasElevator: formValues?.hasElevator || false,
        AddressFiscalCode: homeOrFloorNumber,
        FinalAddress: formValues?.addressComputedFull || finalAddress,
        AddressDetail: formValues?.addressDetail || '',
        Status: true,
        DefaultShippingAddress: formValues?.isDefaultDeliveryAddress || false,
        DefaultBillingAddress: formValues?.isDefaultBillingAddress || false,
        PhoneNumber:
          formValues?.phonePrefix && formValues?.addressPhoneNumber
            ? `${formValues.phonePrefix}${formValues.addressPhoneNumber}`
            : null,
        GeneralTelephone: [
          {
            telephoneId: null,
            number: formValues?.addressPhoneNumber || '',
            telephoneTypeId: formValues?.telephoneTypeId || null,
            Prefix: formValues?.phonePrefix || '+507',
            defaultHome: formValues?.telephoneTypeId === telephoneTypeIds.house,
            defaultWork:
              formValues?.telephoneTypeId === telephoneTypeIds.office,
            defaultMobile:
              formValues?.telephoneTypeId === telephoneTypeIds.cellPhone,
          },
        ],
      }
    }
    return null
  }

  const validatePriceList = () => {
    return canUserAssignPriceLists && valueState.length > 1
  }

  const saveClient = async customer => {
    if (
      formikNatural.values.documentTypeId.toLowerCase() !==
        documentTypeIds.natural.NT &&
      typeClient !== customerLegalId
    ) {
      setLoadingSave(true)
      formikNatural.setSubmitting(true)

      const response = await dispatch(fetchRegisterCustomer({ ...customer }))
      if (response?.data?.Status?.Code === 200) {
        if (valueState?.length) {
          const listPriceIds = valueState.map(list => list.PriceListId)
          const payload = getPriceListPayload(
            listPriceIds,
            response?.data?.Data?.CustomerInfo?.CustomerId
          )
          const res = await dispatch(fetchSaveListPrices(payload))
          if (!res.Message) {
            formikNatural.setSubmitting(false)

            setSaveResultMessage(t('CREATE_CLIENT_T.CLIENT_CREATED'))
          } else {
            formikNatural.setSubmitting(false)

            setSaveResultMessage(res.Message)
            formikLegal.setSubmitting(false)
          }
        } else {
          formikNatural.setSubmitting(false)

          setSaveResultMessage(t('CREATE_CLIENT_T.CLIENT_CREATED'))
        }
        setLoadingSave(false)
        setSuccessModal(true)
        return
      } else {
        console.error('Error :', JSON.stringify(response))
        setLoadingSave(false)
        formikNatural.setSubmitting(false)

        // Si el error es 406, mostrar modal de cliente registrado (duplicado exacto)
        if (response?.Code === 406) {
          // Parsear el mensaje para extraer nombre, RUC/Cédula y aviso operacional del cliente existente
          // Formato: "No es posible crear o editar este cliente porque ya se encuentra registrado.\n\nCliente: OSCAR ESPAÑA\nRUC: 2-333-0001\nAviso Operacional: PE-12345678"
          // O también: "...\nCédula: 2-333-0001\n..."
          const message = response?.Message || ''
          const nameMatch = message.match(/Cliente:\s*(.+?)(?:\n|$)/)
          // Capturar tipo de documento (RUC o Cédula) y su valor
          const documentMatch = message.match(/(RUC|Cédula):\s*(.+?)(?:\n|$)/)
          const operationalNoticeMatch = message.match(
            /Aviso Operacional:\s*(.+?)(?:\n|$)/
          )

          // Solo mostrar el modal si se encontraron los datos del cliente
          if (nameMatch?.[1] && documentMatch?.[2]) {
            handleOpenRegisteredClientModal({
              nombre: nameMatch[1].trim(),
              ruc: documentMatch[2].trim(),
              documentType: documentMatch[1], // 'RUC' o 'Cédula'
              numeroAvisoOperacional: operationalNoticeMatch?.[1]?.trim() || '',
            })
            return
          }
        }

        setSaveResultMessage({
          message: response?.Message,
          code: response?.Code,
        })
        setSuccessModal(true)
      }

      setLoadingSave(false)
    } else if (
      (typeClient === customerNaturalId &&
        formikNatural.values.documentTypeId.toLowerCase() ===
          documentTypeIds.natural.NT) ||
      typeClient === customerLegalId
    ) {
      formikNatural.setSubmitting(true)

      setLoadingSave(true)

      const response = await dispatch(fetchRegisterCustomer({ ...customer }))

      if (response?.data?.Status?.Code === 200) {
        formikNatural.setSubmitting(false)
        setSaveResultMessage(t('CREATE_CLIENT_T.CLIENT_CREATED'))

        if (valueState?.length) {
          const listPriceIds = valueState.map(list => list.PriceListId)
          const payload = getPriceListPayload(
            listPriceIds,
            response?.data?.Data?.CustomerInfo?.CustomerId
          )
          const res = await dispatch(fetchSaveListPrices(payload))
          if (!res.Message) {
            formikNatural.setSubmitting(false)

            setSaveResultMessage(t('CREATE_CLIENT_T.CLIENT_CREATED'))
          } else {
            setSaveResultMessage(res.Message)
            formikLegal.setSubmitting(false)
          }
          setLoadingSave(false)
          setSuccessModal(true)
        } else {
          setLoadingSave(false)
          setSuccessModal(true)
        }
      } else {
        setLoadingSave(false)
        formikLegal.setSubmitting(false)

        // Si el error es 406, mostrar modal de cliente registrado (duplicado exacto)
        if (response?.Code === 406) {
          // Parsear el mensaje para extraer nombre, RUC/Cédula y aviso operacional del cliente existente
          // Formato: "No es posible crear o editar este cliente porque ya se encuentra registrado.\n\nCliente: OSCAR ESPAÑA\nRUC: 2-333-0001\nAviso Operacional: PE-12345678"
          // O también: "...\nCédula: 2-333-0001\n..."
          const message = response?.Message || ''
          const nameMatch = message.match(/Cliente:\s*(.+?)(?:\n|$)/)
          // Capturar tipo de documento (RUC o Cédula) y su valor
          const documentMatch = message.match(/(RUC|Cédula):\s*(.+?)(?:\n|$)/)
          const operationalNoticeMatch = message.match(
            /Aviso Operacional:\s*(.+?)(?:\n|$)/
          )

          // Solo mostrar el modal si se encontraron los datos del cliente
          if (nameMatch?.[1] && documentMatch?.[2]) {
            handleOpenRegisteredClientModal({
              nombre: nameMatch[1].trim(),
              ruc: documentMatch[2].trim(),
              documentType: documentMatch[1], // 'RUC' o 'Cédula'
              numeroAvisoOperacional: operationalNoticeMatch?.[1]?.trim() || '',
            })
            return
          }
        }

        setSaveResultMessage({
          message: response?.Message,
          code: response?.Code,
        })
        setSuccessModal(true)
      }
      setLoadingSave(false)
    }
  }

  const updateClient = async customer => {
    try {
      setLoadingSave(true)
      setHasErrorOnUpdate(false)

      const response = await dispatch(fetchUpdateCustomer(customer))

      // Verificar si la respuesta es un error (response directo sin data.Status)
      // Cuando hay error, response es { Code: 406, Message: "..." }
      // Cuando hay éxito, response es { data: { Status: { Code: 200 } } }
      const isSuccess = response?.data?.Status?.Code === 200
      const errorCode = response?.Code
      const errorMessage = response?.Message

      if (!isSuccess && errorCode) {
        formikNatural.setSubmitting(false)
        formikLegal.setSubmitting(false)

        // Si el error es 406, mostrar modal de cliente registrado (duplicado exacto)
        if (errorCode === 406) {
          // Parsear el mensaje para extraer nombre, RUC/Cédula y aviso operacional del cliente existente
          // Formato con RUC: "...\nRUC: 2-333-0001\n..." o con Cédula: "...\nCédula: 2-333-0001\n..."
          const message = errorMessage || ''
          const nameMatch = message.match(/Cliente:\s*(.+?)(?:\n|$)/)
          // Capturar tipo de documento (RUC o Cédula) y su valor
          const documentMatch = message.match(/(RUC|Cédula):\s*(.+?)(?:\n|$)/)
          const operationalNoticeMatch = message.match(
            /Aviso Operacional:\s*(.+?)(?:\n|$)/
          )

          // Solo mostrar el modal si se encontraron los datos del cliente
          if (nameMatch?.[1] && documentMatch?.[2]) {
            handleOpenRegisteredClientModal({
              nombre: nameMatch[1].trim(),
              ruc: documentMatch[2].trim(),
              documentType: documentMatch[1], // 'RUC' o 'Cédula'
              numeroAvisoOperacional: operationalNoticeMatch?.[1]?.trim() || '',
            })
            setLoadingSave(false)
            return
          }
        }

        throw new Error(errorMessage || 'Error al actualizar cliente')
      }

      if (!isSuccess) {
        formikNatural.setSubmitting(false)
        formikLegal.setSubmitting(false)
        throw new Error(
          response?.data?.Status?.Message || 'Error al actualizar cliente'
        )
      }

      const listPriceIdsAdd = []
      const listPriceIdsDelete = []

      valueState.forEach(list => {
        const isIn = valueEditState.some(
          oldList => oldList.PriceListId === list.PriceListId
        )
        if (!isIn) listPriceIdsAdd.push(list.PriceListId)
      })

      valueEditState.forEach(list => {
        const isIn = valueState.some(
          oldList => oldList.PriceListId === list.PriceListId
        )
        if (!isIn) listPriceIdsDelete.push(list.LinkId)
      })

      // Primero eliminamos las listas de precios si existen
      if (listPriceIdsDelete.length > 0) {
        const deletePromises = listPriceIdsDelete.map(id =>
          dispatch(fetchDeleteListPrices(id))
        )
        const deleteResults = await Promise.all(deletePromises)

        const hasDeleteError = deleteResults.some(
          res => res?.Message && res.Message !== 'OK'
        )

        if (hasDeleteError) {
          const errorMsg = deleteResults.find(res => res?.Message)?.Message
          setSaveResultMessage(
            errorMsg || 'Error al eliminar listas de precios'
          )
          setSuccessModal(true)
          setHasErrorOnUpdate(true)
          return
        }
      }

      // Agregar listas de precios
      if (listPriceIdsAdd.length > 0) {
        const payload = getPriceListPayload(
          listPriceIdsAdd,
          customer?.CustomerInfo?.CustomerId || customer?.customerId,
          true
        )
        const saveRes = await dispatch(fetchSaveListPrices(payload))

        if (saveRes?.Message && saveRes.Message !== 'OK') {
          setSaveResultMessage(saveRes.Message)
          setSuccessModal(true)
          setHasErrorOnUpdate(true)
        } else {
          setSuccessModalUpdate(true)
        }
      } else if (
        listPriceIdsDelete.length > 0 ||
        (listPriceIdsAdd.length === 0 && listPriceIdsDelete.length === 0)
      ) {
        // Mostrar modal de éxito si solo se eliminaron o no hubo ningún cambio
        setSuccessModalUpdate(true)
      }

      needAutoclose && handleClose?.()
      onSuccessUpdate && onSuccessUpdate()
    } catch (error) {
      console.error('Error en updateClient:', error)
      setSaveResultMessage(error.message)
      setSuccessModal(true)
      setHasErrorOnUpdate(true)
    } finally {
      setLoadingSave(false)
    }
  }

  const { formikLegal, formikNatural } = useFormLogic({
    validateAndSetAddress,
    validatePriceList,
    updateClient,
    saveClient,
  })

  const fetchTypeTelephone = async () => {
    const Data = await dispatch(fetchListTelephoneTypes())
    if (Data && Data?.length > 0) {
      setTipoTelefono(Data)
    } else {
      console.error('Error:', Data.toString())
      throw new Error(Data.toString())
    }
    !clientSelected?.edit && setLoader(false)
  }

  const fetchCountries = async () => {
    const Data = await dispatch(fetchListCountries())
    if (Data?.length <= 0) {
      console.error('Error:', Data.toString())
      throw new Error(Data.toString())
    }
  }

  const fetchDocumentType = async DocumentTypeId => {
    const Data = await dispatch(fetchListDocumentTypes(DocumentTypeId))
    if (Data && Data?.length > 0) {
      setDocumentType(Data)
    } else {
      console.error('Error:', Data.toString())
      throw new Error(Data.toString())
    }
  }

  const fetchCustomerbyId = async customerId => {
    setLoader(true)

    const Data = await dispatch(fetchCustomerById(customerId))

    if (Data && Data?.CustomerType) {
      const customerTypeId = Data.CustomerType?.CustomerTypeId
      const payload = {
        CustomerId: customerId,
        PageNumber: 1,
        PageSize: 10,
      }

      if (customerTypeId.toLowerCase() === customerNaturalId.toLowerCase()) {
        setTabNatural(true)
        setTabJuridica(false)

        const infoData = Data
        const PHONE_ID_NATURAL = []
        const NUMBER_NATURAL = []
        const PHONE_TYPE_ID_NATURAL = []

        let PHONEIDNATURAL = ''
        let NUMBERNATURAL = ''
        let PHONETYPEIDNATURAL = ''

        if (
          infoData?.CustomerInfo?.PriceList !== null &&
          infoData?.CustomerInfo?.PriceList?.length > 0 &&
          canUserAssignPriceLists
        ) {
          const listPricesCustomer = await dispatch(
            fetchListPricesByCustomer(payload)
          )
          if (listPricesCustomer?.length > 0) {
            listPricesCustomer.map(list => {
              valueState.push(list)
              valueEditState.push(list)
            })
            setValueState(valueState)
            setValueEditState(valueEditState)
          }
        }

        if (infoData?.TelephoneList !== null) {
          // Search for the phone that has any default field set to true
          const defaultPhoneData = infoData?.TelephoneList?.find(
            item =>
              item?.TelephoneInfo?.DefaultMobile === true ||
              item?.TelephoneInfo?.DefaultHome === true ||
              item?.TelephoneInfo?.DefaultWork === true
          )

          // If no default phone is found, use the first available one
          const phoneData = defaultPhoneData || infoData?.TelephoneList?.[0]

          PHONEIDNATURAL = phoneData?.TelephoneInfo?.TelephoneId || ''
          NUMBERNATURAL = phoneData?.TelephoneInfo?.Number || ''
          PHONETYPEIDNATURAL = phoneData?.TelephoneInfo?.TelephoneTypeId || ''
        } else {
          PHONEIDNATURAL = ''
          NUMBERNATURAL = ''
          PHONETYPEIDNATURAL = ''
        }

        const EMAIL_ID = []
        const ADDRESS_EMAIL = []
        const EMAIL_TYPE_ID = []
        const DEFAULT_EMAIL = []

        let EMAILID = ''
        let ADDRESSEMAIL = ''
        let EMAILTYPEID = ''
        let DEFAULTEMAIL = ''

        if (infoData?.EmailList !== null) {
          // Search for the email that has DefaultEmail set to true
          const defaultEmailData = infoData?.EmailList?.find(
            item => item?.EmailInfo?.DefaultEmail === true
          )

          // If no default email is found, use the first available one
          const emailData = defaultEmailData || infoData?.EmailList?.[0]

          EMAILID = emailData?.EmailInfo?.EmailId || ''
          ADDRESSEMAIL = emailData?.EmailInfo?.Address || ''
          EMAILTYPEID = emailData?.EmailInfo?.EmailTypeId || ''
          DEFAULTEMAIL = emailData?.EmailInfo?.DefaultEmail || false
        } else {
          EMAILID = ''
          ADDRESSEMAIL = ''
          EMAILTYPEID = ''
          // eslint-disable-next-line no-unused-vars
          DEFAULTEMAIL = ''
        }

        setValueStateSelect({
          Description: Data.Gender?.Description || null,
          genderId: Data.Gender?.GenderId,
        })

        infoData?.CustomerGroupList?.find(item => item?.CustomerGroupId)
        const CUSTOMERGROUPID = Data?.CustomerGroupList?.find(
          item => item?.CustomerGroupId
        )?.CustomerGroupId
        const CUSTOMERGROUPDESCRIPTION = Data?.CustomerGroupList?.find(
          item => item?.CustomerGroupId
        )?.Description

        formikNatural.setValues({
          ...formikNatural.values,
          tenant: 2,
          aludraAPP: true,
          firstName:
            Data.CustomerInfo?.FirstName !== null
              ? Data.CustomerInfo?.FirstName
              : '',
          lastName:
            Data.CustomerInfo?.LastName !== null
              ? Data.CustomerInfo?.LastName
              : '',
          fullName:
            Data.CustomerInfo?.FullName !== null
              ? Data.CustomerInfo?.FullName
              : '',
          idNumber:
            Data.CustomerInfo?.IDNumber !== null
              ? Data.CustomerInfo?.IDNumber
              : '',
          birthdate:
            Data.CustomerInfo?.Birthdate !== null
              ? moment(Data.CustomerInfo?.Birthdate).format('YYYY-MM-DD')
              : '',
          cP_Passport: Data.CustomerInfo?.IDNumber
            ? Data.CustomerInfo?.IDNumber
            : '',
          gender: Data.Gender !== null ? Data.Gender?.Description : '',
          genderId: Data.Gender !== null ? Data.Gender?.GenderId : '',
          DV: Data.CustomerInfo?.DV !== null ? Data.CustomerInfo?.DV : '',
          nationalityId:
            Data.CustomerInfo?.NationalityId !== null
              ? Data.CustomerInfo?.NationalityId
              : '',
          documentTypeId:
            Data.CustomerInfo?.DocumentTypeId !== null
              ? Data.CustomerInfo?.DocumentTypeId
              : '',
          customerTypeId:
            Data.CustomerInfo?.CustomerTypeId !== null
              ? Data.CustomerInfo?.CustomerTypeId
              : '',
          customerId:
            Data.CustomerInfo?.CustomerId !== null
              ? Data.CustomerInfo?.CustomerId
              : '',
          generalTelephone: [
            {
              telephoneId: PHONEIDNATURAL,
              number: NUMBERNATURAL,
              telephoneTypeId: PHONETYPEIDNATURAL,
              Prefix: Data.TelephoneList?.[0]?.TelephoneInfo?.Prefix,
            },
          ],
          generalEmail: [
            {
              emailId: EMAILID,
              address: ADDRESSEMAIL,
              emailTypeId: EMAILTYPEID,
              defaultEmail: true,
            },
          ],
          generalGroup: CUSTOMERGROUPID
            ? [
                {
                  customerGroupId: CUSTOMERGROUPID,
                  Description: CUSTOMERGROUPDESCRIPTION,
                },
              ]
            : [],
          rolesName: ['CUSTOMER'],
        })
      } else {
        setTabNatural(false)
        setTypeClient(customerLegalId)
        setTabJuridica(true)

        const info = Data.AdministrativeStoreInfo
        const infoData = Data
        const PHONE_ID = []
        const NUMBER = []
        const TELEPHONE_TYPE_ID = []
        const DEFAULT_MOBILE = []

        let PHONEID = ''
        let PHONE = ''
        let DEFAULTMOBILE = ''
        let TELEPHONETYPEID = ''
        let PREFIX = ''

        const EMAIL_ID = []
        const EMAIL_ADDRESS = []
        const DEFAULT_TYPE_ID = []

        let EMAILID = ''
        let regexEmail = ''
        let DEFAULTTYPEID = ''

        let Tenant = 0
        let StoreId = ''

        if (
          infoData?.CustomerInfo?.PriceList !== null &&
          infoData?.CustomerInfo?.PriceList?.length > 0 &&
          canUserAssignPriceLists
        ) {
          const listPricesCustomer = await dispatch(
            fetchListPricesByCustomer(payload)
          )
          if (listPricesCustomer?.length > 0) {
            listPricesCustomer.map(list => {
              valueState.push(list)
              valueEditState.push(list)
            })
            setValueState(valueState)
            setValueEditState(valueEditState)
          }
        }

        if (info !== null) {
          // Search for the phone that has any default field set to true
          const defaultPhoneData = info?.TelephoneList?.find(
            item =>
              item?.TelephoneInfo?.DefaultMobile === true ||
              item?.TelephoneInfo?.DefaultHome === true ||
              item?.TelephoneInfo?.DefaultWork === true
          )

          // If no default phone is found, use the first available one
          const phoneData = defaultPhoneData || info?.TelephoneList?.[0]

          PREFIX = phoneData?.TelephoneInfo?.Prefix || ''

          // Search for the email that has DefaultEmail set to true
          const defaultEmailData = info?.EmailList?.find(
            item => item?.EmailInfo?.DefaultEmail === true
          )

          // If no default email is found, use the first available one
          const emailData = defaultEmailData || info?.EmailList?.[0]

          PHONEID = phoneData?.TelephoneInfo?.TelephoneId || ''
          PHONE = phoneData?.TelephoneInfo?.Number || ''
          TELEPHONETYPEID = phoneData?.TelephoneInfo?.TelephoneTypeId || ''
          DEFAULTMOBILE = phoneData?.TelephoneInfo?.Number || ''

          EMAILID = emailData?.EmailInfo?.EmailId || ''
          regexEmail = emailData?.EmailInfo?.Address || ''
          DEFAULTTYPEID = emailData?.EmailInfo?.EmailTypeId || ''

          Tenant = Data.CustomerInfo.SaaSId
          StoreId = info?.StoreInfo.StoreId
        } else {
          PHONEID = ''
          PHONE = ''
          TELEPHONETYPEID = ''
          // eslint-disable-next-line no-unused-vars
          DEFAULTMOBILE = ''

          EMAILID = ''
          regexEmail = ''
          DEFAULTTYPEID = ''

          StoreId = ''
        }

        let CUSTOMER_GROUP_ID = []

        let CUSTOMERGROUPID = ''
        let CUSTOMERGROUPDESCRIPTION = ''

        if (infoData?.CustomerGroupList !== null) {
          CUSTOMER_GROUP_ID = infoData?.CustomerGroupList?.find(
            item => item?.CustomerGroupId
          )
          CUSTOMERGROUPID = CUSTOMER_GROUP_ID
            ? CUSTOMER_GROUP_ID?.CustomerGroupId
            : ''
          CUSTOMERGROUPDESCRIPTION = CUSTOMER_GROUP_ID
            ? CUSTOMER_GROUP_ID?.Description
            : ''
        } else {
          CUSTOMERGROUPID = ''
          CUSTOMERGROUPDESCRIPTION = ''
        }

        formikLegal.setValues({
          ...formikLegal.values,
          tenant: Tenant,
          aludraAPP: true,
          customerId:
            Data.CustomerInfo?.CustomerId !== null
              ? Data.CustomerInfo?.CustomerId
              : '',
          country: 'panama',
          email:
            Data.CustomerInfo.Email !== null ? Data.CustomerInfo?.Email : '',
          customerTypeId:
            Data.CustomerType !== null ? Data.CustomerType?.CustomerTypeId : '',
          customerStatus: 'active',
          customerType:
            Data.CustomerType !== null ? Data.CustomerType?.Description : '',
          ruc: Data.CustomerInfo?.RUC !== null ? Data.CustomerInfo?.RUC : '',
          dv: Data.CustomerInfo?.DV !== null ? Data.CustomerInfo?.DV : '',
          documentTypeId:
            Data.CustomerInfo?.DocumentTypeId !== null
              ? Data.CustomerInfo?.DocumentTypeId
              : '',
          legalName:
            Data.CustomerInfo?.LegalName !== null
              ? Data.CustomerInfo?.LegalName
              : '',
          comercialName:
            Data.CustomerInfo?.ComercialName !== null
              ? Data.CustomerInfo?.ComercialName
              : '',
          OperationNoticeNumber:
            Data.CustomerInfo?.OperationNoticeNumber !== null
              ? Data.CustomerInfo?.OperationNoticeNumber
              : '',
          generalStore: [
            {
              StoreId,
              AdministrativeLocation: true,
              generalTelephone: [
                {
                  telephoneId: PHONEID,
                  number: PHONE,
                  telephoneTypeId: TELEPHONETYPEID,
                  defaultMobile: true,
                  Prefix: PREFIX,
                },
              ],
              generalEmail: [
                {
                  emailId: EMAILID,
                  address: regexEmail,
                  emailTypeId: DEFAULTTYPEID,
                },
              ],
            },
          ],
          generalGroup: CUSTOMERGROUPID
            ? [
                {
                  customerGroupId: CUSTOMERGROUPID,
                  Description: CUSTOMERGROUPDESCRIPTION,
                },
              ]
            : [],
          rolesName: ['CUSTOMER'],
        })
      }
    } else {
      console.error('Error:', Data.toString())
      throw new Error(Data.toString())
    }
    setLoader(false)
  }

  const commonProps = {
    validateAndSetAddress,

    tipoTelefono,
    documentType,

    setValueState,
    valueState,

    updateClient,
    saveClient,

    loadingSave,

    setHasAddress,
    hasAddress,
    setCountryCode,
    setProvinceCode,
    setDistrictCode,
    setTownshipCode,
    street,
    setStreet,
    name,
    setName,
  }
  const tabNaturalProps = {
    formikNatural,
    setValueStateSelect,
    valueStateSelect,
    ...commonProps,
  }
  const legalProps = {
    formikLegal,
    ...commonProps,
  }

  useEffect(() => {
    fetchTypeTelephone()
    if (clientSelected.edit) {
      fetchCustomerbyId(clientSelected.customerID)
    }
  }, [])

  useLayoutEffect(() => {
    fetchDocumentType(typeClient)
  }, [typeClient])

  useEffect(() => {
    fetchCountries()
  }, [mapKey])

  if (loader) return <MiniLoading />

  return (
    <>
      <section className="crear-client-content">
        <div className="crear-client-main">
          <Tabs
            transition={false}
            id="noanim-tab-example"
            className="myClass mb-3"
            data-testid="tabs-create-client"
            onSelect={index => {
              setTypeClient(index)
              setMapKey(index)
              clearAddress()
            }}>
            {tabNatural && (
              <Tab
                eventKey={customerTypeId.natural}
                title={t('CREATE_CLIENT_T.NATURAL_TITLE')}>
                <TabNatural props={tabNaturalProps} />
              </Tab>
            )}
            {tabJuridica && createComercialClient && (
              <Tab
                eventKey={customerTypeId.legal}
                title={t('CREATE_CLIENT_T.JURIDIC_TAB')}>
                <TabLegal props={legalProps} />
              </Tab>
            )}
          </Tabs>
        </div>
      </section>

      <AlertModal
        show={successModal}
        data-testid="alert-modal-create-client"
        label={saveResultMessage?.message || saveResultMessage}
        onClick={() => {
          setSuccessModal(false)
          saveResultMessage?.code !== 406 && handleClose?.()
        }}
        isError={hasErrorOnUpdate}
      />

      <AlertModal
        show={successModalUpdate}
        data-testid="alert-modal-update-client"
        label={t('CREATE_CLIENT_T.CHANGES_SAVED')}
        onClick={() => {
          setSuccessModalUpdate(false)
          handleClose && handleClose()
        }}
      />

      <EmailModal />

      <RegisteredClientModal
        open={isRegisteredClientModalOpen}
        onClose={handleCloseRegisteredClientModal}
        registeredClient={registeredClient}
      />
    </>
  )
}

export default CrearCliente
